import type { Directive } from 'vue';

/**
 * Solta o download de um `<video>`/`<audio>` quando ele sai da tela.
 *
 * Remover o elemento do DOM NÃO cancela o download: ele continua até o coletor
 * de lixo passar. No Firefox isso prende a conexão HTTP/1.1 ao S3 (teto de 6
 * por host) e, com alguns vídeos, toda imagem seguinte fica pendente para
 * sempre. `removeAttribute('src')` + `load()` é a forma padrão de abortar o
 * carregamento de mídia; `pause()` antes evita um `pause` tardio em elemento
 * já sem fonte.
 */
export function liberarMidia(el: HTMLMediaElement): void {
    try {
        el.pause();
        el.removeAttribute('src');
        el.querySelectorAll('source').forEach((s) => s.removeAttribute('src'));
        el.load();
    } catch {
        // Elemento já desligado: nada a soltar.
    }
}

export const vLiberarMidia: Directive<HTMLMediaElement> = {
    beforeUnmount: liberarMidia,
};
